import { render, staticRenderFns } from "./newTrainingInstitutionMember.vue?vue&type=template&id=4e673031&scoped=true&"
import script from "./newTrainingInstitutionMember.vue?vue&type=script&lang=js&"
export * from "./newTrainingInstitutionMember.vue?vue&type=script&lang=js&"
import style0 from "./newTrainingInstitutionMember.vue?vue&type=style&index=0&id=4e673031&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e673031",
  null
  
)

export default component.exports